export default "<p>\n  healthinsurances works!\n</p>\n"